const variableIdRegex = /^[A-Z_a-z][\w-]*$/;

export default class QueryVariable {
	static getVariableIdRegex() {
		return variableIdRegex;
	}

	/**
	 * @param {any} variable
	 */
	constructor(variable = null) {
		/** @type {'kid'|'isa'|'file'|'repre'|'attribut'} */
		this.field = variable?.field || 'kid';

		/** @type {string} */
		this.id = variable?.id || '';

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.isa = variable?.isa;

		/** @type {import('@knitiv/api-client-javascript').LinkerKNode} */
		this.isa_linker_kid = variable?.isa_linker_kid || '0';

		/** @type {?string} */
		this.name = variable?.name || null;

		/**
		 * @type {"greater_or_equal" | "less_or_equal" | "between" | "none" | "equal_kid" | "not_equal_kid"
		 *   | "equal_value" | "not_equal_value" | "in" | "not_in" | "less" | "greater" | "not_between" | "begins_with"
		 *   | "not_begins_with" | "contains" | "not_contains" | "ends_with" | "not_ends_with" | "is_empty"
		 *   | "is_not_empty" | "is_null" | "is_not_null" | undefined}
		 */
		this.operator = variable?.operator;

		/** @type {import('@knitiv/api-client-javascript').TypeKid} */
		this.type = variable?.type;

		/** @type {any} */
		this.value = variable?.value || undefined;
	}
}
